module.exports = __webpack_public_path__ + "static/media/warning.bd8fe33c.svg";